import { render, staticRenderFns } from "./RadioHeader.vue?vue&type=template&id=e9165a5e&scoped=true&"
import script from "./RadioHeader.vue?vue&type=script&lang=ts&"
export * from "./RadioHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RadioHeader.vue?vue&type=style&index=0&id=e9165a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9165a5e",
  null
  
)

export default component.exports